import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const marketplaceCustomerService = {
  getList,
  storeOrUpdate
};

function getList(){
  return (
    axios
      .get(
        `${apiEndpoint.marketplaceCustomers}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function storeOrUpdate(data){
  return (
    axios
      .post(
        apiEndpoint.marketplaceCustomers,
        data,
        {
          headers: authHeader()
        }
      )
  ).then(res => {
    if(res && res.status === 200){
      return res.data;
    }
    return {};
  });
}